import React, { useContext, useState } from 'react';
import { useGetProductDetailsQuery } from '../redux-modules/service';
import SessionContext from '../contexts/SessionContext';
import ImageSlider from './components/ImageSlider';
import Sidebar from './components/Sidebar';
import ProductContext from '../contexts/ProductContext';
import ProductInfo from './components/ProductInfo';

export default function ProductDetail({
  productId,
  color,
  type = 'full',
}: { productId: string, color: string, type: 'full' | 'small' }) {
  const session = useContext(SessionContext);
  const [selectedColor, setSelectedColor] = useState<string>(color);
  const { csrfTokenName, csrfTokenValue } = session;

  const handleSelectedColorChange = (newColor: string) => setSelectedColor(newColor);
  let productDetailsBody: any = {
    product: productId,
    color,
  };
  if (csrfTokenName && csrfTokenValue) {
    productDetailsBody = {
      [csrfTokenName]: csrfTokenValue,
      ...productDetailsBody,
    };
  }

  const {
    data: productDetails,
    isLoading: isProductLoading,
    isFetching: isProductFetching,
  } = useGetProductDetailsQuery(productDetailsBody);

  if (isProductLoading || isProductFetching) {
    return null;
  }

  return (
    <ProductContext.Provider value={productDetails}>
      <div className="product-holder lg:-mx-6 xl:-mx-11.7">
        <ImageSlider selectedColor={selectedColor} type={type} />
        <Sidebar
          selectedColor={selectedColor}
          handleSelectedColorChange={handleSelectedColorChange}
          type={type}
        />
        <ProductInfo />
      </div>
    </ProductContext.Provider>
  );
}
